export { fetchFCTOld, fetchFCTNew } from './context-token';
